const DS_shadows = {
  buttonsHover: '5px 17px 32px rgba(0, 0, 0, 0.15)',
  priceCard: '5px 17px 32px rgba(0, 0, 0, 0.07)',
  cardsHover: `5px 17px 43px 0px #DDE3F0`,
};

export default DS_shadows;
